"use client";

import { useSession } from "next-auth/react";
import FullStory from "./FullStory";

export default function FullStoryWithSession() {
  const { data: session } = useSession();

  // Format user data for FullStory
  const user =
    session?.user && session.user.is_logged_in
      ? {
          id: session.user.id,
          fullName: session.user.name || "",
          email: session.user.email,
        }
      : undefined;

  return <FullStory user={user} />;
}
